/**
 * Ticket: SL-669
 * JIRA: https://toolsvilla.atlassian.net/browse/SL-669
 * Description: Modal used to enter Concern about the
 * order, delivery etc.
 * Author: Ankit Nigam
 * Date: 20th Feb 2025
 */
import React, { useState } from "react";
import { Button, Modal, OverlayTrigger, Tooltip } from "react-bootstrap";
import "./CustomModal.css";
import api from "../../seller-apis/api";
/**
 * Raise A Concern Modal
 * @param {*} param0 
 * @returns 
 */
const RaiseConcernModal = ({
  show,
  handleClose,
  submitRaiseConcern,
}) => {
  
  const [concern, setConcern] = useState("");
  const [error, setError] = useState("");
  const submitConcern = () => {
    if (concern == "") {
      setError("Concern cannot be empty!");
    } else {
      setError("");
      submitRaiseConcern(concern);
    }
  };
  return (
    <Modal
      className="custom-modal1 p-10"
      size="md"
      centered
      show={show}
      onHide={handleClose}
    >
      <div class="header-pop p-3 mb-1">
        <div class="header-title">Please select your concern</div>
        <a class="close-pop" onClick={() => handleClose()}>
          ×
        </a>
      </div>
      <Modal.Body style={{ width: "100%" }}>
        <div className="mb-5">
          <div className="answer my-3">
            <select className="form-select" onChange={(e) => setConcern(e.target.value)}>
              <option value="">Please select</option>
              <option value="Courier not picked up">Courier not picked up</option>
              <option value="Stock not available">Stock not available</option>
            </select>
            <div className="error">{error}</div>
          </div>
          <div className="text-center">
            <button
              className="apply-btn px-3 fs-12"
              onClick={() => submitConcern()}
              disabled={concern === null || concern === undefined || concern === "" || concern.trim() === "" ? true : false}
            >
              Submit
            </button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default RaiseConcernModal;
